/* unplugin-vue-components disabled */import { render } from "./detail copy.vue?vue&type=template&id=017e9b29&scoped=true"
import script from "./detail copy.vue?vue&type=script&lang=js"
export * from "./detail copy.vue?vue&type=script&lang=js"

import "../../assets/scss/new3D_detail.scss?vue&type=style&index=0&id=017e9b29&scoped=true&lang=scss&external"
import "./detail copy.vue?vue&type=style&index=1&id=017e9b29&lang=css"
import "./detail copy.vue?vue&type=style&index=2&id=017e9b29&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017e9b29"]])

export default __exports__